module.exports = require('./helpers/bundle-url').getBundleURL('hglyI') + "logo-dark.eefe0b7f.svg";